// Profile of Nikolai Genov, Japanese. Source of the profile page.
module.exports = {
  headline: 'AI & Data Science Lead • ヘルスケア、ライフサイエンス、金融',
  summary: 'バイオインフォマティクスの博士号を持ち、自ら実装も担うリードとして、規制の厳しいヘルスケア、ライフサイエンス、金融の各分野で、AI支援のソフトウェアエンジニアリングとアナリティクスを結びつけています。専門性は、LLM/RAGシステム、MCP統合、臨床データ、最長5年の銀行向け予測、Excelレポーティングの自動化に及びます。R/Pythonによる実装に、チームの調整、品質保証、経営層向けワークショップを組み合わせています。AI Actの認定を取得し、GCPトレーニングを修了しています。',
  imageAlt: 'Nikolai Genovのポートレート',
  personal: {
    position: 'pAIoneer Labs GmbH 共同創業者・代表取締役、Leap Dynamics GmbH 代表取締役',
    location: 'ドイツ、ベルリン',
    languages: 'ドイツ語・英語（流暢）、ブルガリア語（流暢）',
    programmingLanguages: 'R、Python、SQL/SQLite、SAS、MATLAB',
    certifications: 'AI Act認定、GCPトレーニング（2025年）',
    publications: 'Scientific Reports、PLOS Biology、IJMS、Frontiers in Physiology、PLOS ONEに掲載された査読付き論文'
  },
  education: [
    {
      period: '2021年',
      field: '博士課程：バイオインフォマティクス／理論生物学',
      institution: '',
      degree: '学位：博士（Dr. rer. nat.）'
    },
    {
      period: '2015年',
      field: '専攻：バイオインフォマティクス',
      institution: 'Freie Universität Berlin（ベルリン自由大学）',
      degree: '学位：バイオインフォマティクス修士（M.Sc.）'
    },
    {
      period: '2012年',
      field: '専攻：バイオインフォマティクス',
      institution: 'Freie Universität Berlin（ベルリン自由大学）',
      degree: '学位：バイオインフォマティクス学士（B.Sc.）'
    }
  ],
  skills: [
    {
      title: '中核となる専門領域',
      description: 'AI支援エンジニアリング、R/Python、LLM/RAGとMCP、臨床データとバイオインフォマティクス、予測とストレステスト、Excelレポーティング、Shiny、技術リーダーシップ'
    },
    {
      title: 'プログラミングとアナリティクス',
      description: 'R、Python、SQL/SQLite、SAS、MATLAB、ggplot2、scikit-learn、Keras/TensorFlow'
    },
    {
      title: 'アプリケーションとレポーティング',
      description: 'R Shiny、Streamlit、Tableau、Leaflet、R Markdown、knitr、LaTeX、Excel/Word/PDFレポーティングの自動化'
    },
    {
      title: 'AIとインテグレーション',
      description: 'OpenCode、ChatGPT、Model Context Protocol（MCP）、Ollama、vLLM、LM Studio、Open WebUI、RAG、n8n、Flowise、人によるレビューを伴うAI支援開発'
    },
    {
      title: 'エンジニアリング',
      description: 'Azure DevOps、GitLab CI/CD、Docker、Camunda、Linux、Microsoft Azure、Google Cloud Platform'
    },
    {
      title: 'バイオインフォマティクス',
      description: 'RNA-seq、マイクロアレイ、選択的スプライシング／アイソフォーム、遺伝子セットエンリッチメント解析、パスウェイ／ネットワーク解析、ゲノムアセンブリ、生存時間解析、Bioconductor、Cytoscape、GEO、ArrayExpress、Ensembl BioMart、UniProt/Swiss-Prot、GO、Reactome、KEGG、BioGRID、STRING、ChEMBL'
    },
    {
      title: '臨床データ',
      description: 'EDC、CRF、エディットチェック、DMP、データバリデーション計画、UAT、SAEリコンシリエーション、CDISC SDTM/ADaM、RAW/SDTM/ADaMパイプライン、QC'
    }
  ],
  positions: [
    {
      period: '2022年〜2024年4月',
      title: 'レポーティング自動化、T-Systems／欧州中央銀行（ECB）',
      description: [
        '金融時系列の統計レポーティング用Rライブラリを構築。Reticulateを用いてFAMEのロジックをR/Pythonへ移行し、Word/PDF出力を自動化。',
        'Excelレポートを自動生成するパイプラインを開発。アナリティクスをCamundaと統合し、GitLab CI/CD、ユニットテスト、リンティング、SonarQube、ドキュメント作成を支援。',
        'チームリーダーの代理を務め、スプリント計画、技術面の調整、品質保証、ステークホルダーと直接向き合うデリバリーに貢献。'
      ]
    },
    {
      period: '2025年6月〜2025年12月',
      title: 'Data Science & Risk Analytics Consultant、銀行業界',
      description: [
        '最長5年の計画期間を対象とする予測モデルを開発し、ストレステストを実装。',
        '既存のRコードを書き直してリファクタリングし、4つの業務プロセスを最適化。実装とドキュメント作成には、人によるレビューを伴うAI支援開発を活用。',
        'R/Shinyによる分析ワークフローと、Excelレポートを自動生成するパイプラインを構築。業務要件を分析の実装へと具体化。'
      ]
    },
    {
      period: '2025年6月〜2026年6月',
      title: 'Clinical Data Manager、製薬／臨床試験',
      description: [
        'EDCのセットアップ、CRF設計、エディットチェック、ユーザーロール、データ転送仕様、UATを管理。CRO、検査機関、治験チームとの調整を担当。',
        'DMP、バリデーション計画、SAEリコンシリエーション計画、UAT文書を作成・レビュー。GCPが関わる環境で、RベースのバリデーションワークフローとShinyアプリケーションを開発。'
      ]
    },
    {
      period: '2026年7月',
      title: '臨床データパイプライン、Dr. Falk Pharma',
      description: [
        'OpenCodeとAI支援開発を用いて、RでRAW/SDTM/ADaMパイプラインを構築。バリデーション、QC、トレーサビリティ、Excelレポートの自動生成パイプラインを含む。'
      ]
    },
    {
      period: '2026年',
      title: 'AI支援による監査証跡レポーティング、Miltenyi Biotec',
      description: [
        'OpenCodeとAI支援開発を用いて、監査証跡レポートとExcelレポートの自動生成パイプラインを実装。レポートロジック、デバッグ、ドキュメント作成、人によるレビューを含む。'
      ]
    },
    {
      period: '2019年〜現在',
      title: 'CEO・共同創業者／AI & Data Lead、Leap Dynamics GmbH',
      description: [
        'ヘルスケア、ライフサイエンス、金融、AIの各分野で、コンサルティングと技術デリバリーを統括。自ら手を動かす実装に、チームの調整とステークホルダーとのコミュニケーションを組み合わせる。',
        'LLM/RAGインフラとMCPベースのツール統合を設計。コード生成、リファクタリング、テスト、ドキュメント作成のために、人によるレビューを伴うOpenCode支援のR/Pythonワークフローを確立。'
      ]
    },
    {
      period: '2022年〜現在',
      title: 'がん登録・バイオバンク、Medical University Pleven（プレヴェン医科大学）',
      description: [
        '全国がん登録データを分析し、臨床および研究のステークホルダー向けにShinyダッシュボードを構築。5種類のがんを対象に、統合、ドキュメント作成、バイオバンクのワークフローを支援。'
      ]
    },
    {
      period: '2025年〜現在',
      title: 'Lead Developer、AI Map Europe（ai-map.eu）',
      description: [
        '本番運用に対応したR Shinyアプリケーションを構築。CSVデータをSQLiteへ移行し、管理者認証、機関管理、訪問者分析、有料掲載、SMTP通知付きの問い合わせフォームを追加。',
        'レスポンシブなUI/UX、SEO、構造化データ、sitemap/robots対応を改善。入力バリデーション、出力エスケープ、ログイン試行の制限、検証済みレコードのみの公開を追加。ELLIS、CAIRNE、AI NATION、NET4AI、INSAIT、AI-on-Demandを用いて400以上の機関を監査し、出所の記録とデプロイ／セキュリティのドキュメントを整備。'
      ]
    },
    {
      period: '2024年〜現在',
      title: 'LLMによる金融ニュース分析、Leap Dynamics（社内プロジェクト）',
      description: [
        'LLM、APIデータ、PDFレポートの自動生成、Streamlitインターフェース、n8nによるオーケストレーション、Flowiseを活用したワークフローテストを用いて、定期的なセンチメント分析ワークフローを構築。'
      ]
    },
    {
      period: '2025年',
      title: '経営層向けワークショップ、BVMW',
      description: [
        'BVMWのネットワークにおいて、経営者クラスの参加者を対象としたワークショップを実施。'
      ]
    },
    {
      period: '2015年〜2019年',
      title: '研究員、Humboldt-Universität（フンボルト大学）／Charité、ベルリン',
      description: []
    },
    {
      period: '2015年〜2017年',
      title: 'CTO・共同創業者、Promethano GmbH',
      description: [
        'ライフサイエンス向けソフトウェアおよび時系列アプリケーション。'
      ]
    }
  ]
};
